import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Announcement } from '@shared/announcement/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
  private readonly basePath = '/announcement';

  constructor(
    private readonly http: ApiClientService,
  ) {
  }

  load(): Observable<Announcement> {
    return this.http.get<Announcement>(this.basePath);
  }
}
